"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Column = _interopRequireDefault(require("../Column"));

var _Row = _interopRequireDefault(require("../Row"));

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _Button = _interopRequireDefault(require("../Button"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _common = require("../../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerNavBar = function DatePickerNavBar(_ref) {
  var localeUtils = _ref.localeUtils,
      yearsLimit = _ref.yearsLimit,
      displayDate = _ref.displayDate,
      onChange = _ref.onChange,
      onNext = _ref.onNext,
      onPrevious = _ref.onPrevious;
  // months
  var months = localeUtils.getMonths();
  var monthsOptions = months.map(function (m, i) {
    return {
      title: m,
      value: "".concat(i)
    };
  });
  var monthValue = "".concat(displayDate.getMonth()); // years

  var currentYear = new Date().getFullYear();
  var fromMonth = new Date(currentYear - yearsLimit, 0);
  var toMonth = new Date(currentYear + yearsLimit, 11);
  var years = [];

  for (var year = fromMonth.getFullYear(); year <= toMonth.getFullYear(); year += 1) {
    years.push(year);
  }

  var yearsOptions = years.map(function (y) {
    return {
      title: y,
      value: "".concat(y)
    };
  });
  var yearValue = "".concat(displayDate.getFullYear());
  return _react.default.createElement(_Row.default, {
    between: true,
    middle: true,
    className: "MHub-DatePicker-Navbar"
  }, _react.default.createElement(_Column.default, {
    col: true
  }, _react.default.createElement(_Dropdown.default, {
    className: "MHub-DatePicker-Dropdown",
    name: "month",
    value: monthValue,
    withArrow: false,
    onChange: onChange,
    options: monthsOptions
  })), _react.default.createElement(_Dropdown.default, {
    className: "MHub-DatePicker-Dropdown",
    name: "year",
    value: yearValue,
    withArrow: false,
    onChange: onChange,
    options: yearsOptions
  }), _react.default.createElement(_Button.default, {
    color: "blue",
    basic: true,
    icon: _react.default.createElement(_Icon.default, {
      name: _Icon.default.ChevronLeft
    }),
    onClick: onPrevious
  }), _react.default.createElement(_Button.default, {
    color: "blue",
    basic: true,
    icon: _react.default.createElement(_Icon.default, {
      name: _Icon.default.ChevronRight
    }),
    onClick: onNext
  }));
};

DatePickerNavBar.propTypes = {
  localeUtils: _propTypes.default.shape({}),
  yearsLimit: _propTypes.default.number,
  displayDate: _common.customPropTypes.moment,
  onChange: _propTypes.default.func,
  onNext: _propTypes.default.func,
  onPrevious: _propTypes.default.func
};
DatePickerNavBar.defaultProps = {
  localeUtils: null,
  yearsLimit: 50,
  displayDate: new Date(),
  onChange: null,
  onNext: null,
  onPrevious: null
};
var _default = DatePickerNavBar;
exports.default = _default;